/* eslint-disable class-methods-use-this */
/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.formParent = this.closest('product-form');
      if(this.formParent){
         this.form = this.formParent.querySelector('form') || null;
         this.formType = this.formParent.dataset.format || null;
      }
      this.variant_json = this.querySelector('[data-variantJSON]');
      this.container = this.formType === 'product-card' || this.formType === 'quickview'  ? this.closest('[data-product-card]') : this.closest('[data-product-container]');
    }

    connectedCallback() {
      this.updateSwatchLabel();
      // if (this.formType === 'product-page') this.onVariantChange('load');
      let formtemplate = this.formParent?.dataset.template || '';
      if (this.formType === 'product-page' && formtemplate != 'virtual-race') this.onVariantChange('load');
      this.checkAndUpdateVariantAvailability();
      this.addEventListener('change', (evt) => {
        this.onVariantChange();
      });
    }

    updateSwatchLabel(){
      const colorSwatchContainer = this.querySelector('.color-swatch');
      if(colorSwatchContainer){
        const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
        colorSwatches.forEach(swatch => {
          const colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
          const swatchStyle = Utility.getSwatchStyle(colorHandle);
          swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
        });
      }
    }
  
    /**
     * Trigger this function variant is changed
     */
    onVariantChange() {
      this.setCurrentVariant();
      eventBus.publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          container: this.container,
          variant: this.currentVariant,
        },
      });

      this.updateOptionLabel(this.container);
      this.checkAndUpdateVariantAvailability();
      if(this.dataset.selectedid && this.currentVariant){
        this.dataset.selectedid = this.currentVariant.id;
      }
       document.dispatchEvent(new CustomEvent('Option:VariantChange', { detail: {"variant":this.currentVariant,"element": this}, bubbles: true, cancelable: false }));

      if(!this.formType) return;
      if (this.formType === 'product-card' || this.formType === 'quickview') {
        this.updateProductCardImage();
      }
      if (this.formType === 'product-page'){
        if (!this.currentVariant && window.globalSpace.product) {
          this.currentVariant = window.globalSpace.product.variants[0];
        }
        window.globalSpace.product.currentVariant = this.currentVariant;
      }
      if(this.formType == 'quickview' || this.formType === 'product-page'){
        let sku_element = this.container.querySelectorAll('[data-event-variant-sku]');
        if(sku_element.length && this.currentVariant && this.currentVariant.sku){
          sku_element.forEach(el => el.innerText = this.currentVariant.sku);
        }
      }
      if(typeof this.formParent?.updateProductDetails == 'function'){
      this.formParent.updateProductDetails(this.container, this.currentVariant);
    }
    }

    updateProductCardImage() {
      if (!this.currentVariant?.featured_media) return;
      if(this.formType == 'quickview'){
        let eventDetail ={
          variant : this.currentVariant
        }
        document.dispatchEvent(new CustomEvent('Quickview:VariantChange', { detail: eventDetail, bubbles: true, cancelable: false }));
        return;
      }
      if(!this.container){
        this.container = this.formType === 'product-card' || this.formType === 'quickview'  ? this.closest('[data-product-card]') : this.closest('[data-product-container]');
      }
      const variantId = this.currentVariant.id.toString();
      const query = `
            query MyQuery {
              node(id: "gid://shopify/ProductVariant/${variantId}") {
                ... on ProductVariant {
                      id
                      title
                      metafield(namespace: "custom", key: "variant_media") {
                        id
                        references(first: 3) {
                          edges {
                            node {
                              ... on MediaImage {
                                id
                                image {
                                  url
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              `;
        fetch(`${window.globalSpace.apiDomain}/api/2023-01/graphql.json`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": "382d0c774e95be1f0d7c90e6c08bba49"
          },
          body: JSON.stringify({ query })
        })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then(res => {
          const variantData = res?.data?.node;
          const edges = variantData?.metafield?.references?.edges || [];
          const images = edges.map(edge => edge?.node?.image?.url).filter(Boolean);
          const variantTitle = variantData?.title || this.currentVariant.title;
          const productImageWrapper = this.container.querySelector('.product-images-wrapper');
          const mainImage = productImageWrapper?.querySelector('.main-image');
          const secondaryImage = productImageWrapper?.querySelector('.secondary-image');
          if (mainImage) {
            mainImage.src = images[0] || '';
            mainImage.srcset = images[0] || '';
            mainImage.alt = variantTitle;
          }
          if (secondaryImage) {
            secondaryImage.src = images[1] || images[0] || '';
            secondaryImage.srcset = images[1] || images[0] || '';
            secondaryImage.alt = variantTitle;
          }
        })
        .catch(error => {
          console.error("Error fetching variant metafields:", error);
        });
    }

    checkAndUpdateVariantAvailability() {
      const optionContainers = Array.from(this.querySelectorAll('fieldset, .product-form__input--dropdown'));
      if (optionContainers.length >= 2) {
        this.updateVariantAvailability();
      }
    }

    updateVariantAvailability() {
      const variants = this._getVariantData();
      if (!variants) return;
      const selectedOptions = this.selectedOptionValues;
      if (!selectedOptions) return;

      const optionContainers = Array.from(this.querySelectorAll('fieldset, .product-form__input--dropdown'));
      // Update availability for all options based on current selections
      optionContainers.forEach((container, optionIndex) => {
        const radioInputs = container.querySelectorAll('input[type="radio"]');
        if (radioInputs.length > 0) {
          this.updateRadioInputsAvailability(radioInputs, variants, selectedOptions, optionIndex);
        }

        const dropdownContainer = container.querySelector('.toggle-content-wrap');
        if (dropdownContainer) {
          const dropdownInputs = dropdownContainer.querySelectorAll('input.variant_selector');
          this.updateDropdownInputsAvailability(dropdownInputs, variants, selectedOptions, optionIndex);
        }
      });
    }

    updateRadioInputsAvailability(inputs, variants, selectedOptions, currentOptionIndex) {
      inputs.forEach(input => {
        const optionValue = input.value;
        const { exists, isAvailable } = this.checkVariantAvailability(variants, selectedOptions, currentOptionIndex, optionValue);
        const swatchLi = input.closest('li');
        this.updateOptionVisibility(input, swatchLi, exists, isAvailable, currentOptionIndex);
      });
      this.handleAutoSelection(inputs);
    }

    updateDropdownInputsAvailability(inputs, variants, selectedOptions, currentOptionIndex) {
      inputs.forEach(input => {
        const optionValue = input.value;
        const { exists, isAvailable } = this.checkVariantAvailability(variants, selectedOptions, currentOptionIndex, optionValue);
        const menuItem = input.closest('li');
        this.updateOptionVisibility(input, menuItem, exists, isAvailable, currentOptionIndex);
      });
    }

    // Helper method to check variant availability
    checkVariantAvailability(variants, selectedOptions, currentOptionIndex, optionValue) {
      const exists = variants.some(variant => {
        return variant.options[currentOptionIndex] === optionValue && this.matchesOtherSelectedOptions(variant, selectedOptions, currentOptionIndex);
      });
      const isAvailable = variants.some(variant => {
        return variant.available && variant.options[currentOptionIndex] === optionValue && this.matchesOtherSelectedOptions(variant, selectedOptions, currentOptionIndex);
      });
      return { exists, isAvailable };
    }

    // Helper method to update option visibility and disabled state
    updateOptionVisibility(input, container, exists, isAvailable, optionIndex) {
      const isColorOption = optionIndex === 0;
      if (isColorOption) {
        // Always show color options
        if (container) container.style.display = '';
        this.updateDisabledState(input, isAvailable);
      } else {
        // For other options, hide if they don't exist
        if (exists) {
          if (container) container.style.display = '';
          this.updateDisabledState(input, isAvailable);
        } else {
          if (container) container.style.display = 'none';
        }
      }
    }

    // Helper method to update disabled state
    updateDisabledState(input, isAvailable) {
      if (isAvailable) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    }

    // Helper method to handle auto-selection
    handleAutoSelection(inputs) {
      const optionContainer = inputs[0]?.closest('fieldset, .product-form__input--dropdown');
      if (!optionContainer) return;

      const selectedInput = optionContainer.querySelector('input[type="radio"]:checked');
      if (!selectedInput || selectedInput.closest('li')?.style.display === 'none') {
        const firstVisibleInput = Array.from(inputs).find(input =>
          input.closest('li')?.style.display !== 'none'
        );
        if (firstVisibleInput) {
          firstVisibleInput.checked = true;
          firstVisibleInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    // Helper method to check if a variant matches all other selected options
    matchesOtherSelectedOptions(variant, selectedOptions, currentOptionIndex) {
      return selectedOptions.every((selectedOption, index) => {
        // Skip the current option index since we're checking that separately
        if (index === currentOptionIndex) return true;
        return variant.options[index] === selectedOption;
      });
    }

    get selectedOptionValues() {
      return Array.from(this.querySelectorAll('select option[selected], fieldset input[type="radio"]:checked, custom-select input[type="radio"]:checked')).map(({ value }) => value);
    }

    /**
     * change value of currentVariant when variant being changed 
     */
    setCurrentVariant() {
      this.currentVariant = false;
      const options = this.selectedOptionValues;
      const variants = this._getVariantData();
      variants.find(variant => {
          if (variant.options.every((option, i) => options[i] === option)) {
            this.currentVariant = variant;
          }
      });
      
    }
  
    /**
     * Update selected option name label
     */
    updateOptionLabel(form) {
      if (!form) return;
      const metafieldMap = {};
      const metafieldString = this.dataset.metafieldMap || '';
      if (metafieldString) {
        metafieldString.split(',').forEach(pair => {
          const [key, value] = pair.split(':');
          if (key && value) {
            metafieldMap[key.trim()] = value.trim();
          }
        });
      }
      const optionGroups = form.querySelectorAll('[data-optionindex]');
      optionGroups.forEach(option => {
        const label = option.querySelector('.selected-option');
        const checkedInput = option.querySelector('input:checked');
        if (label && checkedInput) {
          const optionValue = checkedInput.value;
          const mappedValue = metafieldMap[optionValue] || optionValue;
          const optionType = label.dataset.optionType?.toLowerCase();
          // If we have a mapping and the value exists in it, use the mapped value
          if (Object.keys(metafieldMap).length > 0 && metafieldMap[optionValue]) {
            label.textContent = metafieldMap[optionValue];
          } else {
            // Otherwise, use the default formatting
            if (optionType === 'color') {
              label.textContent = optionValue.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
            } else if (optionType === 'size') {
              label.textContent = optionValue.toUpperCase();
            } else {
              label.textContent = optionValue;
            }
          }
        }
      
      });
    }

    /**
     * Store the all the variants json
     */
    _getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
      return this.variantData;
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }

    get optionValues() {
      return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
        ({ dataset }) => dataset.optionValueId
      );
    }
}
customElements.define('variant-selects', VariantSelects);